import { Callout } from "../components/Callout.js";

export const meta = {
  title: "HubSpot 再認可",
  updatedAt: "2026-05-22",
};

export function Content() {
  return (
    <>
      <p>
        以下のケースでは HubSpot との再認可（再接続）が必要になります。
      </p>

      <h2>再認可が必要なケース</h2>
      <ul>
        <li>
          HubSpot 側でアプリを削除した後、再度連携したい
        </li>
        <li>
          当サービスのアップデートに伴い、ダッシュボードに{" "}
          <strong>「HubSpot 再接続が必要です」</strong>のバナーが表示された
        </li>
        <li>
          ステータス同期や送信時に「HubSpot 認証エラー」が表示された
        </li>
      </ul>

      <h2>再認可の手順</h2>
      <ol>
        <li>
          ダッシュボードの「<strong>接続設定</strong>」タブを開きます
        </li>
        <li>
          「HubSpot 接続」セクションの「<strong>再接続（アカウント変更）</strong>」
          ボタンをクリックします
        </li>
        <li>
          新しいタブで HubSpot の承認画面が開くので、
          「<strong>アプリを接続する</strong>」をクリックします
        </li>
        <li>
          自動的にダッシュボードに戻り、「接続済み」と表示されれば完了です
        </li>
      </ol>

      <Callout type="info" title="既存データへの影響">
        再認可してもテナントの設定・送信履歴・Client ID 等のデータはすべて
        保持されます。HubSpot 側のアクセス権限のみが更新されます。
      </Callout>

      <h2>機能アップデート後の再接続バナー</h2>
      <p>
        当サービスのアップデートで HubSpot との連携内容が変わった場合、
        既存ユーザーの皆様には再接続をお願いしています。
        ダッシュボード上部に「機能アップデートに伴い HubSpot 再接続が必要です」
        のバナーが表示されたら、バナー内のボタンから再接続してください。
      </p>

      <Callout type="warning" title="再接続しないと一部機能が動かない">
        バナー表示後に再接続せずに使い続けると、新機能が動作しなかったり、
        既存機能が部分的に失敗することがあります。表示後は速やかに再接続を
        行ってください。
      </Callout>

      <h2>うまくいかない時</h2>
      <ul>
        <li>
          <strong>承認画面で操作できない</strong>: HubSpot 管理者権限を持つ
          アカウントでログインしているか確認してください
        </li>
        <li>
          <strong>「サービス利用停止中」エラー</strong>: テナントが一時利用停止
          されています。<a href="/contact">お問い合わせフォーム</a> よりご相談ください
        </li>
        <li>
          <strong>承認後にエラーが出る</strong>: ブラウザの Cookie 設定や、別の
          HubSpot ポータルにログイン中になっていないか確認してください
        </li>
      </ul>
    </>
  );
}
